import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { Address, Country } from '@safarilaw-webapp/feature/co-manage/data-access';

import { distinctUntilChanged, pairwise } from 'rxjs/operators';
import { SafariValidators } from '../../forms/validation/safari-validators';

export abstract class FormHelper {
  static buildAddress(item: Address, formBuilder: FormBuilder = null): Address | FormGroup {
    const result = new Address();
    if (item) {
      FormHelper._initAddressFrom(result, item);
    }

    if (formBuilder) {
      return formBuilder.group(result);
    } else {
      return result;
    }
  }

  static addressHasUserProvidedValue(item: Address): boolean {
    if (item == null) {
      return false;
    }
    /* Check whether any value has been provided by the user, but skip country because we default that */
    return Object.entries(item).any(([k, v]) => k !== 'country' && String.isNullOrEmpty(v?.toString()) === false);
  }

  static _initAddressFrom(target: Address, source: Address) {
    target.street1 = source?.street1 || null;
    target.street2 = source?.street2 || null;
    target.city = source?.city || null;
    target.zipCode = source?.zipCode || null;
    target.state = source?.state || null;
    target.country = source?.country || Country.UnitedStates;
  }

  static getFormAddressChangeObservable(form: AbstractControl, prefix: string) {
    return form.get(prefix + '.country').valueChanges.pipe(distinctUntilChanged(), pairwise());
  }
  static watchAddressChanges(form: AbstractControl, prefix: string, prev, current) {
    const selectedCountry = current;
    if (prev && current !== prev) {
      form.get(prefix + '.state').reset(null);
    }
    if (selectedCountry == Country.UnitedStates) {
      form.get(prefix + '.state').enable();
    } else if (selectedCountry == Country.Canada) {
      form.get(prefix + '.state').enable();
    } else {
      form.get(prefix + '.state').disable();
    }
    form.get(prefix + '.zipCode').updateValueAndValidity();
    form.get(prefix + '.state').updateValueAndValidity();
  }
  static setupDateLessThanValidators(dateRangeStart: AbstractControl, dateRangeEnd: AbstractControl) {
    const dateErrorMessage = 'Date Range End must be after Date Range Start';
    dateRangeStart.setValidators([SafariValidators.dateEqualOrLessThan(dateRangeEnd, dateErrorMessage)]);
    dateRangeEnd.setValidators([SafariValidators.dateEqualOrGreaterThan(dateRangeStart, dateErrorMessage)]);

    dateRangeStart.valueChanges.pipe(distinctUntilChanged()).subscribe(() => {
      dateRangeEnd.updateValueAndValidity();
    });
    dateRangeEnd.valueChanges.pipe(distinctUntilChanged()).subscribe(() => {
      dateRangeStart.updateValueAndValidity();
    });
  }
}
